// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 기본 스타일 */
* {
  box-sizing: border-box;
}

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--bg-tertiary);
  color: var(--text-primary);
  line-height: 1.6;
}

#root {
  height: 100%;
  overflow-x: hidden;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* 버튼 공통 기본값 (전역).
   배경/폭/색은 지정하지 않는다 — 지정하면 인라인 background-color나 .btn-* 를
   덮어 색 충돌이 생긴다(과거 Login.css 전역 button 누수 사고). */
button {
  white-space: nowrap;
  font-family: inherit;
  font-size: inherit;
  cursor: pointer;
}

button:disabled {
  cursor: not-allowed;
}

h1, h2, h3, h4, h5, h6 {
  white-space: nowrap;
}

/* fieldset legend 줄바꿈 방지 */
legend {
  white-space: nowrap;
}

/* 공통 유틸리티 클래스 */
.text-center { text-align: center; }
.d-flex { display: flex; }
.d-none { display: none; }
.justify-content-between { justify-content: space-between; }
.align-items-center { align-items: center; }
`, "",{"version":3,"sources":["webpack://./src/styles/base.css"],"names":[],"mappings":"AAAA,WAAW;AACX;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,oCAAoC;EACpC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;aACW;AACb;;AAEA;;gDAEgD;AAChD;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB,eAAe,kBAAkB,EAAE;AACnC,UAAU,aAAa,EAAE;AACzB,UAAU,aAAa,EAAE;AACzB,2BAA2B,8BAA8B,EAAE;AAC3D,sBAAsB,mBAAmB,EAAE","sourcesContent":["/* 기본 스타일 */\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\nhtml, body {\r\n  height: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nbody {\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background-color: var(--bg-tertiary);\r\n  color: var(--text-primary);\r\n  line-height: 1.6;\r\n}\r\n\r\n#root {\r\n  height: 100%;\r\n  overflow-x: hidden;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\n/* 버튼 공통 기본값 (전역).\r\n   배경/폭/색은 지정하지 않는다 — 지정하면 인라인 background-color나 .btn-* 를\r\n   덮어 색 충돌이 생긴다(과거 Login.css 전역 button 누수 사고). */\r\nbutton {\r\n  white-space: nowrap;\r\n  font-family: inherit;\r\n  font-size: inherit;\r\n  cursor: pointer;\r\n}\r\n\r\nbutton:disabled {\r\n  cursor: not-allowed;\r\n}\r\n\r\nh1, h2, h3, h4, h5, h6 {\r\n  white-space: nowrap;\r\n}\r\n\r\n/* fieldset legend 줄바꿈 방지 */\r\nlegend {\r\n  white-space: nowrap;\r\n}\r\n\r\n/* 공통 유틸리티 클래스 */\r\n.text-center { text-align: center; }\r\n.d-flex { display: flex; }\r\n.d-none { display: none; }\r\n.justify-content-between { justify-content: space-between; }\r\n.align-items-center { align-items: center; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
